<template>
    <div class="processContainer">
      <div class="dashProcess">
        <div>

          <div id="toolbar" v-if="!readOnly">
            <b-button v-if="!readOnly" id='lock-readonly' size="sm" class="mb-2" @click="setReadOnly()">
              <b-icon v-if="readOnly" icon="lock" aria-hidden="true"></b-icon> 
              <b-icon v-else icon="unlock" aria-hidden="true"></b-icon>
              Apenas Leitura 
            </b-button>
            
            <div> 
              <b-button class='btnSave'  variant="success" @click="saveFlowchart">
                <b-icon icon="cloud-upload" aria-hidden="true"></b-icon>
                Salvar flowsheet
              </b-button>
            </div>

            <b-button @click="factoryCtrl(typesNodes.Text).setNewNode(openDialog)"> Texto </b-button>
            <b-button @click="factoryCtrl(typesNodes.Line).setNewNode(openDialog)"> Linha </b-button>
            <b-button @click="factoryCtrl(typesNodes.Circle).setNewNode(openDialog)"> Circulo </b-button>
            <b-button @click="factoryCtrl(typesNodes.Triangle).setNewNode(openDialog)"> Triangulo </b-button>
            <b-button @click="factoryCtrl(typesNodes.Input).setNewNode(openDialog)"> Entrada </b-button>
            <b-button @click="factoryCtrl(typesNodes.Occupation).setNewNode(openDialog)"> Ocupação </b-button>
            <b-button @click="factoryCtrl(typesNodes.Current).setNewNode(openDialog)"> Caixa de Texto </b-button>
            <b-button @click="factoryCtrl(typesNodes.InputCana).setNewNode(openDialog)"> Cana </b-button>
            <b-button @click="factoryCtrl(typesNodes.Tanque).setNewNode(openDialog)"> Tanque </b-button>
            <b-button @click="factoryCtrl(typesNodes.Milling, 'Moenda 6 ternos').setNewNode(openDialog)"> Moenda </b-button>
            <b-button @click="factoryCtrl(typesNodes.Boiler).setNewNode(openDialog)"> Caldeira </b-button>
            <b-button @click="factoryCtrl(typesNodes.EthanolCentrifuge).setNewNode(openDialog)"> Centrífuga de Etanol </b-button>
            <b-button @click="factoryCtrl(typesNodes.DistillationColumnA, 'Coluna Destilação A').setNewNode(openDialog)"> Coluna de Destilação A </b-button>
            <b-button @click="factoryCtrl(typesNodes.DistillationColumnB).setNewNode(openDialog)"> Coluna de Destilação B </b-button>
            <b-button @click="factoryCtrl(typesNodes.EvaporativeCondenser).setNewNode(openDialog)"> Condensador Evaporativo </b-button>
            <b-button @click="factoryCtrl(typesNodes.SugarCooker).setNewNode(openDialog)">Cozedor</b-button>
            <b-button @click="factoryCtrl(typesNodes.Vat).setNewNode(openDialog)"> Cuba </b-button>
            <b-button @click="factoryCtrl(typesNodes.EnergyDemand).setNewNode(openDialog)"> Demanda de Energia </b-button>
            <b-button @click="factoryCtrl(typesNodes.Deaerator).setNewNode(openDialog)">Desaerador </b-button>
            <b-button @click="factoryCtrl(typesNodes.Decanter).setNewNode(openDialog)">Decantador</b-button>
            <b-button @click="factoryCtrl(typesNodes.Desuperheater).setNewNode(openDialog)"> Dessuperaquecedor </b-button>
            <b-button @click="factoryCtrl(typesNodes.Diffuser).setNewNode(openDialog)"> Difusor </b-button>
            <b-button @click="factoryCtrl(typesNodes.ContinuousDorna).setNewNode(openDialog)"> Dorna Contínua </b-button>
            <b-button @click="factoryCtrl(typesNodes.Evaporator).setNewNode(openDialog)">Evaporador</b-button>
            <b-button @click="factoryCtrl(typesNodes.Evaporator2).setNewNode(openDialog)">Evaporador2</b-button>
            <b-button @click="factoryCtrl(typesNodes.FermentationBatch).setNewNode(openDialog)"> Fermentação Batelada </b-button>
            <b-button @click="factoryCtrl(typesNodes.Flotador).setNewNode(openDialog)"> Flotador </b-button>
            <b-button @click="factoryCtrl(typesNodes.Filter3).setNewNode(openDialog)"> Filtro 3 </b-button>
            <b-button @click="factoryCtrl(typesNodes.RegeneratorD).setNewNode(openDialog)"> Regenerador D </b-button>
            <b-button @click="factoryCtrl(typesNodes.Dryer).setNewNode(openDialog)"> Secador </b-button>
            <b-button @click="factoryCtrl(typesNodes.CargoLoss).setNewNode(openDialog)"> Perda de Carga </b-button>
            <b-button @click="factoryCtrl(typesNodes.TowerCO2).setNewNode(openDialog)"> Torre CO2 </b-button>
            <b-button @click="factoryCtrl(typesNodes.CoolingTower).setNewNode(openDialog)"> Torre de Resfriamento </b-button>
            <b-button @click="factoryCtrl(typesNodes.Turbine).setNewNode(openDialog)"> Turbina </b-button>
            <b-button @click="factoryCtrl(typesNodes.Flash).setNewNode(openDialog)"> Flash/Multijato </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Extração (Moenda)').setNewNode(openDialog)"> Extração (Moenda) </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Extração (Difusor)').setNewNode(openDialog)"> Extração (Difusor) </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Tratamento Fábrica').setNewNode(openDialog)"> Tratamento Fábrica </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Tratamento Destilaria').setNewNode(openDialog)"> Tratamento Destilaria </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Tratamento Filtrado').setNewNode(openDialog)"> Tratamento Filtrado </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Evaporação').setNewNode(openDialog)"> Evaporação </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Fábrica Açúcar').setNewNode(openDialog)"> Fábrica Açúcar </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Fermentação').setNewNode(openDialog)"> Fermentação </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Destilaria').setNewNode(openDialog)"> Destilaria </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Geração Vapor').setNewNode(openDialog)"> Geração Vapor </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Cogeração').setNewNode(openDialog)"> Cogeração </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Tratamento Vinhaça').setNewNode(openDialog)"> Tratamento Vinhaça </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Fabrica Levedura').setNewNode(openDialog)"> Fabrica Levedura </b-button>
            <b-button @click="factoryCtrl(typesNodes.Area, 'Refinaria').setNewNode(openDialog)"> Refinaria </b-button>
          </div>
        </div>
        
        <div>
          <div id="canvas"
            @mousedown="selectionArea.start($event)"
            @mousemove="selectionArea.move($event)"
          /> 
          <Dialog
            :dialogVisible="showDialog"
            :node="nodeRefToDialog"
          />
          <DialogReadOnly 
            :dialogVisibleShow="showDialogReadOnly"
            :node="nodeRefToDialog"
            :types="typesNodes"
          />
        </div>
        
      </div>
    </div>
</template>

<script>
import * as d3 from "d3";
import axios from 'axios'
import Dialog from './Dialog.vue';
import DialogReadOnly from './DialogReadOnly'
import { urlMainAPI, defaultSuccess } from "@/global";
import { SingletonEnginnering } from "./nodes/_service/singletonEngineering";
import { SingletonFlowchart } from "./nodes/_service/singletonFlowchart";
import { GetNewController } from "./nodes/_service/factoryController";
import { cleanUndoRedo } from "./nodes/_service/undoRedo"
import { Selection } from "./nodes/_service/selectionService"
import { ShortCuts } from "./utils/ShortCuts"
import { mapState } from "vuex";
import { Types } from "./utils/nodeTypes"
import imageOfTheAreas from './utils/imagesOfTheAreas'

export default {
  name: "FlowChart",
  components: { Dialog, DialogReadOnly },

  inject:[ 'showLoading' ],

  props:["sendNodes", 'reloadNodes', 'resetNodes'],

  computed: mapState(["user"]),

  data() {
    return {
      unitId: parseInt(this.$store.state.user.UnitId),
      typesNodes: new Types(),
      selectionArea: new Selection(),
      loading: true,
      showDialog: 0,
      showDialogReadOnly: 0,
      nodeRefToDialog: null,
      factoryCtrl: GetNewController,
      areas: imageOfTheAreas,
      readOnly: false
    };
  },
  
  watch: {
    sendNodes() {
      let listInputProperties = SingletonFlowchart.Memory.getPropertiesToSimulation();
      let tableFlowChart = SingletonEnginnering.setTableFlowChart(listInputProperties);
      console.log('tableFlowChart :>> ', tableFlowChart);
      this.$emit("sendInputList", tableFlowChart);      
    },

    async reloadNodes(objectStructure) {
      console.log('Carregando dados salvos no período selecionado :>> ', );
      SingletonEnginnering.load(objectStructure)
      let properties = SingletonFlowchart.Memory.getProperties()
      await SingletonEnginnering.updatePropertyValues(properties)
      SingletonFlowchart.Memory.reloadNodes();
      this.showLoading(false)
    },

    async resetNodes() {
      await SingletonFlowchart.Memory.resetPropertyValues()
      SingletonFlowchart.Memory.reloadNodes();
    }
  },

  methods: {
    openDialog(node){
      this.nodeRefToDialog = node

      if(!this.readOnly){
        SingletonFlowchart.unSelectNode();
        this.showDialog++;
        return
      }

      if(this.typesNodes.inputNodes.includes(node.type))
        this.showDialogReadOnly++;
    },

    removeNode() {
      let selection = SingletonFlowchart.selected
      let selected = SingletonFlowchart.selectedNodes
      if(selection || selected){
        d3.selectAll(`.SelectionNode`).remove();
        SingletonFlowchart.removeNodeSelected();
      }
    },

    unSelected(){
      SingletonFlowchart.unSelectNode();
      this.selectionArea.cancelSelection();
    },

    async saveFlowchart(){
      let nodes = SingletonFlowchart.Memory.getNodesToSave();
      console.log('Salvar :>> ', nodes);

      let flowchart = {
        id: this.unitId,
        configuration: JSON.stringify(nodes)
      }
      
      const url = `${urlMainAPI}/saveflowchart`;
      await axios
        .post(url, flowchart)
        .then((res) => {
          defaultSuccess(res.data);
        })
        .catch(console.log);
      
      console.log('flowchart :>> ', flowchart);
    },

    async loadDatabaseNodes(){
      let obj = {}
      obj.id = this.unitId

      await axios
        .get(`${urlMainAPI}/loadflowchart/${this.unitId}`)
        .then(async res => {
          if(res.data && res.data.configuration != "[]"){
            SingletonFlowchart.Memory.clear()
            await this.loadNodes(res.data.configuration)
          }
          else
            defaultSuccess(this.$t('nao-ha-diagrama-para-ser-carregado'));
        })
        .catch(error => console.log('Falha em loadDatabaseNodes>>', error));
      
      defaultSuccess(this.$t('tela-atualizada-com-sucesso'))
    },
   
    async loadNodes(data) {
      const parsedData = JSON.parse(data);
      await parsedData.forEach(node => {
        node.readOnly = this.readOnly;
        let ctr = GetNewController(node.type, node.name)
        ctr.loadNode(node, this.openDialog)
      });
      console.log(`${parsedData.length} elementos do flowsheet carregados!`)
      SingletonFlowchart.SaveStatus();
    },

    loadmodelObjectStructure (){
      setTimeout(function() {
        if(!SingletonEnginnering.isLoaded){
          console.log("Carregando Engenharia...")
          let xml = localStorage.xml ? JSON.parse(localStorage.xml) : ''
          
          if(xml && xml.scenarioObjectStructure){
            console.log("Carga do engenharia pela memória")
            SingletonEnginnering.load(xml.scenarioObjectStructure)
          }else{
            let url = `${urlMainAPI}/getmodelobjectstructure`
            let xml = JSON.parse(localStorage.getItem('xml'))
            let obj = {}
            obj.scenario = xml.scenario
            obj.scenarioResult = xml.scenarioResult
            
            axios.post(url,obj).then(obj => {
              console.log("Carga do engenharia pela base de dados")
              SingletonEnginnering.load(obj.data)
              xml.scenarioObjectStructure = obj.data
              localStorage.xml = JSON.stringify(xml)
            }).catch(e => 
              console.log('Falha no recebimento da requisição getmodelobjectstructure :>> ', e )
            );
          }
        }
      }, 1500);
    },

    configSVG(){
      let that = this
      let svg = d3.select("#canvas")
        .call(d3.drag().on('end', function(){ that.unSelected() }))
        .append("svg")
        .attr("id", "svg")
        .call(d3.zoom().on("zoom", function(event) { svg.attr("transform", event.transform).node() }))
        .on("dblclick.zoom", null)
        .append("g")
        .attr("id", "board")

      SingletonFlowchart.svg = svg;
      cleanUndoRedo();
    },
    
    showToobar(){
      if(!this.readOnly){
        document.querySelector('.dashProcess').style['grid-template-columns'] = '150px 1fr'
        document.querySelector('#toolbar').style.display = 'block'
      }else{
        document.querySelector('.dashProcess').style['grid-template-columns'] = '100%'
        SingletonFlowchart.setReadOnly();
      }
    },

    async setReadOnly() {
      this.readOnly = !this.readOnly;
      SingletonFlowchart.readOnly = this.readOnly;
      SingletonFlowchart.Memory.clear()
      document.querySelector('#canvas').innerHTML = '';
      
      this.showLoading(true)
      this.configSVG();
      await this.loadDatabaseNodes();
      this.showToobar();
      ShortCuts.Kill();
      this.showLoading(false)
    },

    checkReadyOnly(){
      this.readOnly = !this.user.Permissions.editarplanejamentoproducao.allowed;
      SingletonFlowchart.readOnly = this.readOnly
    }
  },

  async mounted() {
    this.showLoading(true)
    this.checkReadyOnly()
    this.configSVG();
    this.loadmodelObjectStructure();
    await this.loadDatabaseNodes();
    this.showToobar();
    ShortCuts.Init(this);
    this.showLoading(false)
  }
};
</script>

<style src="./index.css"></style>

<style>

#svg {
  background-color: #fff;
  border-radius: 5px;
  width: 100%;
  height: 67vh;
  border: 1px solid #0008;
  box-shadow: 0px 0px 3px #0008;
}

.selected{
  border: 2px solid #222;
}

.dashProcess {
  display: grid;
  grid-template-columns: 100%;
  align-content: stretch;
  width: 100%;
  height: 100%;
}

#toolbar {
  display: none;
  grid-column-start: 1;
}

#canvas {
  grid-column-start: 2;
  cursor: crosshair;
}

.processContainer {
  padding: 0;
  margin: 0;
  padding: 0 10px 0px 0px;
}

@media (max-height: 720px) { 
  #svg {
    height: 480px;
  }

  #nodesPCP.group-buttons {
    height: 53vh;
  }
}

@media (min-height: 760px) { 
  #svg {
    height: 690px;
  }
}

@media (min-height: 900px) { 
  #svg {
    height: 720px;
  }
}

@media (min-height: 1050px) { 
  #svg {
    height: 880px;
  }
}

@media (min-height: 1600px) { 
  #svg {
    height: 1430px;
  }
}

</style>
